import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    LoginPageContainer: {
        overflow: 'hidden',
        maxHeight: '100%',
        position: 'relative',
        zIndex: 2,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            content: '',
            background: '#000',
            opacity: '.3',
            zIndex: 1,
        }
    },
    LogoLoginPage: {
        paddingLeft: '12px',
        width: 480,
    },
    LogoIT: {
        // fontSize: '60px',
        color: '#fff',
    },
    LogoSM: {
        color: '#fff',
        padding: '0 !important',
        position: 'relative',
        marginLeft: '24px',
        fontWeight: 'bold',
        marginTop: '10px'
    },
    LogoFPT: {
        width: 80,
        objectFit: 'cover',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: 'var(--itsm-bg-btn)',
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    FromGroup: {
        position: 'relative'
    },
    FormLabel: {
        position: 'absolute',
        top: '14px',
        left: '22px'
    },
    FormLabelRight: {
        position: 'absolute',
        top: '14px',
        right: '22px',
    },
    LoginField: {
        backgroundColor: 'rgba(255,255,255,.08)',
        color: 'white !important',
        height: '50px',
        borderRadius: '40px',
        paddingLeft: '50px',
        paddingRight: '20px',
        '&::placeholder': {
            color: '#fff',
            opacity: '.4 !important'
        }
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        height: '50px',
        borderRadius: '40px',
        color: '#fff',
        background: 'transparent',
        boxShadow: 'none',
        border: '1px solid white',
        '&:hover': {
            opacity: '.9',
            color: "#fff",
            backgroundColor: '#135d57',
            boxShadow: 'none !important'
        },
        '&:active': {
            boxShadow: 'none !important'
        },
    },
    TieuDe: {
        color: '#fff',
        marginBottom: '20px',
        fontSize: '32px',
    },
    noremember: {
        color: "#fff !important",
        '&:hover': {
            color: "#fff",
        }
    }
}));
